.page {
  font-family: system-ui, sans-serif;
  color: #505050;
  scroll-behavior: smooth;
}

/* HERO */
.hero {
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: url('/cdn/greenwall/landing/img02.jpg') center/cover no-repeat;
  padding: 4rem 1rem;
}

.heroTitle {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .heroTitle {
    font-size: 4rem;
  }
}

.heroSubtitle {
  font-size: 1.25rem;
  max-width: 32rem;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .heroSubtitle {
    font-size: 1.5rem;
  }
}

.heroButton {
  font-size: 1rem;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 9999px;
  background: #256f46;
  color: #fffdf7;
  cursor: pointer;
}

.heroButton:hover {
  background: #1f5c39;
}

/* SECTIONS */
.section {
  padding: 4rem 1rem;
  background: #f7f7f7;
}

.section:nth-of-type(odd) {
  background: #ffffff;
}

.sectionTitle {
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 3rem;
}

/* FEATURES */
.featuresGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 60rem;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .featuresGrid {
    grid-template-columns: 1fr 1fr;
  }
}

.featureCard {
  display: flex;
  gap: 1rem;
  background: #ffffff;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  align-items: flex-start;
}

.featureIcon {
  font-size: 2rem;
  line-height: 1;
}

.featureTitle {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.featureText {
  color: #505050;
  line-height: 1.6;
}

/* GALLERY */
.gallery {
  padding: 4rem 1rem;
}

.galleryGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  max-width: 70rem;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .galleryGrid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.galleryImage {
  width: 100%;
  height: 24rem;
  object-fit: cover;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* CTA */
.cta {
  padding: 4rem 1rem;
  background: #6bc292;
  color: #fffdf7;
  text-align: center;
}

.ctaTitle {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .ctaTitle {
    font-size: 2.5rem;
  }
}

.ctaSubtitle {
  font-size: 1.125rem;
  margin-bottom: 2rem;
  max-width: 40rem;
  margin-left: auto;
  margin-right: auto;
}

.ctaForm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  max-width: 28rem;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .ctaForm {
    flex-direction: row;
  }
}

.input {
  flex: 1;
  min-width: 0;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.75rem;
  color: #505050;
}

.button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.75rem;
  background: #fffdf7;
  color: #256f46;
  font-weight: 600;
  cursor: pointer;
}

.button:hover {
  background: #f0f0f0;
}

/* FOOTER */
.footer {
  padding: 2rem 1rem;
  background: #111111;
  color: #aaaaaa;
  text-align: center;
  font-size: 0.875rem;
}
